module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-banner row"
  }, [_c('div', {
    staticClass: "col col-md-5",
    staticStyle: {
      "align-self": "center"
    }
  }, [_c('v-img', {
    staticClass: "is-desctop",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "lazy-src": "/static/img/bannerImg.jpg",
      "src": "/static/img/bannerImg.jpg",
      "alt": ""
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "text-wrapper animate__animated animate__fadeIn col-md-6 col-sm-12"
  }, [_c('div', {
    staticClass: "banner-text__title",
    domProps: {
      "innerHTML": _vm._s(_vm.arr[_vm.bannerThis].title)
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "z-index": "2"
    }
  }, [_c('div', [_c('div', {
    key: _vm.bannerThis,
    staticClass: "banner-text__list-sub"
  }, _vm._l((_vm.subTitleList), function(item, index) {
    return _c('div', {
      key: 'subTitleList' + item.index,
      staticClass: "is-desctop banner-text__list-sub__item"
    }, [_c('span', {
      class: Number(item.index) == Number(_vm.bannerThis) ? 'selection-text' : '',
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.bannerThis = item.index
        }
      }
    }, [_vm._v("\n              " + _vm._s(item.title) + "\n            ")]), _vm._v(" "), (index + 1 < _vm.subTitleList.length) ? _c('span', {
      staticStyle: {
        "padding": "1em"
      }
    }, [_vm._v("·")]) : _vm._e()])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "banner-text__sub-title",
    domProps: {
      "innerHTML": _vm._s(_vm.arr[_vm.bannerThis].title2)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "button-text"
  }, [_c('ui_btn', {
    staticClass: "is-desctop",
    attrs: {
      "type": "main-btn"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.arr[_vm.bannerThis].buttonDescription)
    },
    on: {
      "click": function($event) {
        return _vm.bannerFunc(_vm.arr[_vm.bannerThis].href)
      }
    }
  })], 1)]), _vm._v(" "), _c('img', {
    staticClass: "is-mobile mobile-img",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/img/bannerImg.jpg",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "is-mobile btn-mobile-wrapper"
  }, [_c('ui_btn', {
    attrs: {
      "type": "gray-btn"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.arr[_vm.bannerThis].buttonDescription)
    },
    on: {
      "click": function($event) {
        return _vm.bannerFunc(_vm.arr[_vm.bannerThis].href)
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row is-mobile row-mobile"
  }, [_c('div', {
    staticClass: "col mobile-wrapper-role"
  }, [_c('img', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "src": "/static/img/left-banner.png"
    },
    on: {
      "click": function($event) {
        return _vm.changeBanner(0)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-role"
  }, [_vm._v("\n          " + _vm._s(_vm.arr[_vm.bannerThis].chooserDescription) + "\n        ")]), _vm._v(" "), _c('img', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "src": "/static/img/right-banner.png"
    },
    on: {
      "click": function($event) {
        return _vm.changeBanner(1)
      }
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-07b7c3b2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/bannerMain.vue
// module id = 336
// module chunks = 2